module.exports = __webpack_public_path__ + "static/img/ys_btn1.1adee63.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/ys_btn1.png
// module id = CitR
// module chunks = 7